import React, { useState } from "react";

import { Container, Row, Col } from "react-bootstrap";
import { MDBDataTableV5 } from "mdbreact";
import CustomGreenButton from "../../../components/shared/custom-green-button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Skeleton from "@material-ui/lab/Skeleton";
import TableColumnDropdown from "../../../components/shared/table-column-dropdown/table-column-dropdown";

import TvIcon from "@material-ui/icons/Tv";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import swal from "sweetalert";

import { GENERAL_URL_API } from "../../../shared/urls";
import { columnasLibrosMasLeidos } from "../../../shared/data/columnas";
import exportFromJSON from "export-from-json";

import ClienteFiltro from "../../../components/shared/cliente-filtro";

const ReporteLecturasLibrosMasLeidos = () => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [fullRows, setFullRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentFilters, setCurrentFilters] = useState(null);
  const [lastQueryKeyForFullRows, setLastQueryKeyForFullRows] = useState("");

  const changeColumnStatus = (columnField) => {
    const temp = [...columns];
    const index = temp.findIndex((column) => column.field === columnField);
    temp[index].isVisible = !temp[index].isVisible;
    setColumns(temp);
  };

  const handleConsultar = async (filtros) => {
    setLoading(true);
    setCurrentFilters(filtros);

    const fd = new FormData();
    fd.append("cliente", filtros.usuariosCsv || "");
    if (filtros.fechaInicio && filtros.fechaFin) {
      fd.append("fechaInicio", filtros.fechaInicio);
      fd.append("fechaFin", filtros.fechaFin);
    }
    if (filtros.superInstituto) {
      fd.append("superInstituto", filtros.superInstituto);
    }
    if ((filtros.institutos || []).length > 0) {
      fd.append("institutos", filtros.institutos.join(";"));
    }
    fd.append("maxEntradas", 5000);

    const res = await fetch(`${GENERAL_URL_API}/verDatos/reporteLecturasLibros.php`, {
      method: "POST", credentials: 'include',
      body: fd,
    });
    const resJSON = await res.json();
    if (resJSON.info && resJSON.info.includes("No hay resultados")) {
      await swal({ title: "Error", text: "No se encontraron entradas validas", icon: "error" });
    }
    let tempColumns = columnasLibrosMasLeidos.map((c) => ({ ...c }));
    tempColumns.map((_, index) => (tempColumns[index].isVisible = true));
    setRows(resJSON.data || []);
    setColumns(tempColumns);
    setFullRows([]);
    setLastQueryKeyForFullRows("");
    setLoading(false);
  };

  // Helpers para exportaciones bajo demanda
  const buildClienteStr = () => {
    return currentFilters?.usuariosCsv || "";
  };

  const buildQueryKey = () => {
    const keyObj = {
      cliente: buildClienteStr(),
      fechaInicio: currentFilters?.fechaInicio || "",
      fechaFin: currentFilters?.fechaFin || "",
      superInstituto: currentFilters?.superInstituto || "",
      institutos: (currentFilters?.institutos || []).join(";") || "",
    };
    return JSON.stringify(keyObj);
  };

  const ensureFullRowsLoaded = async () => {
    const currentKey = buildQueryKey();
    if (fullRows.length > 0 && currentKey === lastQueryKeyForFullRows) return fullRows;

    const fd = new FormData();
    fd.append("cliente", buildClienteStr());
    if (currentFilters?.fechaInicio && currentFilters?.fechaFin) {
      fd.append("fechaInicio", currentFilters.fechaInicio);
      fd.append("fechaFin", currentFilters.fechaFin);
    }
    if (currentFilters?.superInstituto) {
      fd.append("superInstituto", currentFilters.superInstituto);
    }
    if ((currentFilters?.institutos || []).length > 0) {
      fd.append("institutos", currentFilters.institutos.join(";"));
    }
    fd.append("maxEntradas", 50000000);

    const res = await fetch(`${GENERAL_URL_API}/verDatos/reporteLecturasLibros.php`, {
      method: "POST", credentials: 'include',
      body: fd,
    });
    const resJSON = await res.json();
    if (resJSON.info && resJSON.info.includes("No hay resultados")) {
      await swal({ title: "Error", text: "No se encontraron entradas validas", icon: "error" });
      setFullRows([]);
      setLastQueryKeyForFullRows(currentKey);
      return [];
    }
    setFullRows(resJSON.data || []);
    setLastQueryKeyForFullRows(currentKey);
    return resJSON.data || [];
  };

  // Descarga directa desde el API (blob)
  const downloadExcelFromApi = async () => {
    const fd = new FormData();
    fd.append("cliente", buildClienteStr());
    if (currentFilters?.fechaInicio && currentFilters?.fechaFin) {
      fd.append("fechaInicio", currentFilters.fechaInicio);
      fd.append("fechaFin", currentFilters.fechaFin);
    }
    if (currentFilters?.superInstituto) {
      fd.append("superInstituto", currentFilters.superInstituto);
    }
    if ((currentFilters?.institutos || []).length > 0) {
      fd.append("institutos", currentFilters.institutos.join(";"));
    }
    fd.append("maxEntradas", 50000000);
    fd.append("descargar", 1);

    const res = await fetch(`${GENERAL_URL_API}/verDatos/reporteLecturasLibros.php`, {
      method: "POST", credentials: 'include',
      body: fd,
    });

    const contentType = res.headers.get('content-type') || '';
    if (!res.ok) {
      try {
        const errJson = contentType.includes('application/json') ? await res.json() : null;
        throw new Error(errJson?.info || `Error ${res.status}`);
      } catch (e) {
        throw new Error(`Error ${res.status}`);
      }
    }

    if (contentType.includes('application/json')) {
      const err = await res.json();
      throw new Error(err?.info || 'No se pudo generar el archivo');
    }

    const blob = await res.blob();
    let filename = `reporte-libros-mas-leidos-${new Date().toISOString().split('T')[0]}.xlsx`;
    const disposition = res.headers.get('content-disposition') || '';
    const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
    const extracted = match ? (match[1] || match[2]) : null;
    if (extracted) {
      try { filename = decodeURIComponent(extracted); } catch (_) { filename = extracted; }
    }

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleCsvExport = async () => {
    const data = await ensureFullRowsLoaded();
    exportFromJSON({
      data,
      fileName: "reporte-libros-mas-leidos"+"-"+new Date().toISOString().split('T')[0],
      exportType: exportFromJSON.types.csv,
    });
  };

  const handleJsonExport = async () => {
    const data = await ensureFullRowsLoaded();
    exportFromJSON({
      data,
      fileName: "reporte-libros-mas-leidos"+"-"+new Date().toISOString().split('T')[0],
      exportType: exportFromJSON.types.json,
    });
  };

  const handleExcelExport = async () => {
    try {
      await downloadExcelFromApi();
    } catch (e) {
      await swal({ title: "Error", text: e.message || 'No se pudo descargar el archivo', icon: "error" });
    }
  };

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <TvIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Reporte de lecturas de libros más leídos</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <ClienteFiltro onSubmit={handleConsultar} submitting={loading} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <div className="d-flex align-items-center">
              <MenuBookIcon />
              <div className="admin-main-title-dark-gray ml-2 mt-1">
                Libros más leídos por cliente
              </div>
            </div>
            <div className="admin-muted-text-small mt-1 mb-4">
              Consulta de libros más leídos por los filtros seleccionados
            </div>

            {rows.length <= 0 || columns.length <= 0 ? (
              <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
              </>
            ) : (
              <>
                <TableColumnDropdown
                  columns={columns}
                  changeColumnStatus={changeColumnStatus}
                />
                <br />

                <ButtonGroup size="small" variant="contained" className="my-3">
                  <CustomGreenButton
                    onClick={() => {
                      const dat = [...rows];
                      navigator.clipboard
                        .writeText(JSON.stringify(dat))
                        .then(async () => {
                          await swal({ title: "Se ha copiado la tabla!", icon: "success" });
                        });
                    }}
                  >
                    Copy
                  </CustomGreenButton>
                  <CustomGreenButton onClick={handleCsvExport}>
                    CSV
                  </CustomGreenButton>
                  <CustomGreenButton onClick={handleJsonExport}>
                    JSON
                  </CustomGreenButton>
                  <CustomGreenButton onClick={handleExcelExport}>
                    EXCEL
                  </CustomGreenButton>
                </ButtonGroup>
                <MDBDataTableV5
                  small
                  responsive
                  searchTop
                  searchBottom={false}
                  barReverse
                  pagingTop
                  striped
                  bordered
                  data={{
                    columns: columns.filter((obj) => obj.isVisible),
                    rows: rows,
                  }}
                  noBottomColumns
                  order={["numeroLecturas", "desc"]}
                  entriesOptions={[5, 10, 20, 50]}
                  entriesLabel="Numero de filas"
                  searchLabel="Buscar"
                  paginationLabel={["Anterior", "Siguiente"]}
                  infoLabel={["Mostrando filas", "a", "de", "filas"]}
                  fullPagination
                />
              </>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ReporteLecturasLibrosMasLeidos;


